import React from "react";
import ClosedStatusPin from "../../../assets/images/ClosedStatusPin.svg";
import OnProgressStatusPin from "../../../assets/images/OnProgressStatusPin.svg";
import ValidStatusPin from "../../../assets/images/ValidStatusPin.svg";
import NotStartedStatusPin from "../../../assets/images/NotStartedStatusPin.svg";

const Legend = () => {
  const legendItems = [
    { label: "On Progress", icon: OnProgressStatusPin },
    { label: "Valid", icon: ValidStatusPin },
    { label: "Closed", icon: ClosedStatusPin },
    { label: "Not Started", icon: NotStartedStatusPin },
  ];

  return (
    <div
      style={{
        position: "absolute",
        bottom: "10px",
        left: "40px",
        zIndex: 1000,
        border: "1px solid #ddd",
        padding: "10px 20px",
        borderRadius: "8px",
        backgroundColor: "#ffffff",
        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
        fontFamily: "Arial, sans-serif",
        maxWidth: "200px",
      }}
    >
      <h4
        style={{
          color: "#0190A0",
          marginTop: "0px",
          marginBottom: "12px",
          fontWeight: "extrabold",
          textAlign: "center",
        }}
      >
        LEGENDA
      </h4>
      {legendItems.map((item, index) => (
        <div
          key={index}
          style={{ display: "flex", alignItems: "center", marginBottom: 8 }}
        >
          <img
            src={item.icon}
            alt={item.label}
            style={{ width: "16px", height: "16px", marginRight: "12px" }}
          />
          <span style={{ fontSize: "14px", color: "#333" }}>{item.label}</span>
        </div>
      ))}
    </div>
  );
};

export default Legend;
